import { Injectable } from '@angular/core';
import {GraphService} from "../../../../../kernel/graphql/services/graph.service";
import subscriptionDatashape from "../datashape/subscription.datashape";
import {first, map} from "rxjs";
import {ISubscriptionRejectionReason} from "../interfaces/reject-subscription-reason.interface";
import {ISubscriptionVerificationResult} from "../interfaces/subscription-verification-result.interface";

@Injectable()
export class SubscriptionApiService {

  constructor(private graphService: GraphService) {}

  getSubscription(id: string, dataShape: string = subscriptionDatashape) {
    return this.graphService
      .constructQuery<{ getSubscription: any }>(
        dataShape,
        'getSubscription',
        { id }
      )
      .pipe(
        first(),
        map(res => res.data)
      );
  }

  rejectSubscription(id: string, reasons: ISubscriptionRejectionReason[]) {
    return this.graphService
      .constructMutation<{ rejectSubscription: {code: number, text: string} }>(
        "rejectSubscription",
        { subscriptionId: "ID", reasons: '[SubscriptionRejectionReasonInput]' },
        { subscriptionId: id,  reasons},
        ['text', 'code']
      )
      .pipe(
        first(),
        map((res) => ({ ...res, data: res.data?.rejectSubscription }))
      );
  }

  acceptSubscription(id: string, masriId?: number) {
    return this.graphService
      .constructMutation<{ rejectSubscription: {code: number, text: string} }>(
        "acceptSubscription",
        { subscriptionId: "ID!", masriId: 'Int' },
        { subscriptionId: id,  masriId},
        ['text', 'code']
      )
      .pipe(
        first(),
        map((res) => ({ ...res, data: res.data?.rejectSubscription }))
      );
  }

  verifySubscription(id: string) {
    return this.graphService
      .constructMutation<{ verifySubscription: ISubscriptionVerificationResult }>(
        "verifySubscription",
        { subscriptionId: "ID!"},
        { subscriptionId: id},
        ['status', 'name', 'masriId']
      )
      .pipe(
        first(),
        map((res) => ({ ...res, data: res.data?.verifySubscription }))
      );
  }
}
